import React, {FC} from 'react';

import iconStateSuccess from "assets/icons/commons/source-state-active.svg"
import {t} from "i18next";
import Input from "../../commons/Input/Input";

interface DataSourceProps {
  externalWhService: string
  externalWhID: string
}

export const ExternalWarehouseService: FC<DataSourceProps> = ({
  externalWhService,
  externalWhID
}) => {

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  return (
    <div
      className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
    >
      <div className="flex max-h-11 rounded items-center">
        <div className="flex items-center min-w-36">
          <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
            <img src={iconStateSuccess} className="mr-2" />
            {t<string>(externalWhService, { ns: "messages" })}
          </div>
        </div>
        <div className="flex mr-auto">
        </div>
        <div>
        </div>
      </div>

      <div className={'mt-4'}>
        <Input
            id="ext_id"
            name="ext_id"
            value={externalWhID}
            label={t<string>("Внешний ID", { ns: "messages" })}
            changeHandler={() => {}}
            customClassName={customInputClassName}
            customLabelClassName="text-sm"
            require={false}
            disabled={true}
        />
      </div>

    </div>
  );
};
